import Vue from 'vue';
import {eventHub} from '@/main'
import reservationService from "@/api/reservation/reservationService";
import payInService from "@/api/reservation/payInService";
import { RESERVATION_LIST_TYPE } from '@/enums/reservationListType';

const state = {
    listFrom: null,
    listTo: null,
    reservationsLabels: {},
    reservationsPickupLabels: {},
    reservations: [],
    filteredEvents: [],
    filteredTime: null,
    selectedReservation: null,
    selectedProductCommissions: null,
    selectedProductCommissionsProductId: null,
    loadingPeopleFinancials: false,
    newReservationSetup: null,
    newReservation: null,
    clonedReservation: null,
    invoices: null,
    eventReservations: null,
    reservationCancelNow: true,
    isSavingReservation: false,
    reservation:{
        agent: {},
        product:{},
        event:{},
        billing:{
            promoCode: "",
            promoCodeDiscountType: null,
            promoCodeDiscountCode: null,
            discountType: 0,
            discountValue: null,
            description: "",
            details: {
                vat: "",
                businessName: "",
                address: "",
                city: "",
                country: 176
            },
            invoices: null,
        },
        payments: [],
        currentChannelCommission: {
            productValueType: 1,
            productValue: 0,
            componentValueType: 1,
            componentValue: 0,
            isToOverwriteProduct: false,
            isToOverwriteComponent: false,
            transportValueType: 1,
            transportValue: 0
        },
        customer:{
            prefix: null,
            name: null,
            surname: null,
            phone: null,
            accomodation: null,
            room: null,
            email: null,
            country: null,
            dial: null,
            isInvalid: true,
            sendEmailCopy: true
        },
        helper: {
            totalToPay: null,
        },
        transport:{
            transfers:[]
        },
        notes: [
            {
                note: null,
                noteVisibilityMomentType: 1,
                type: 1
            }
        ],
        creatorAgent: null,
        creatorSupplier: null,
        creatorUserAccount: null
    },
    reservationSelectedProduct: null,
    reservationSelectedEvent: null,
    isAddingReservation: false,
    isGettingReservationById: false,
    reservationCalculations: {
        attachDiscount: {
            value: 0,
            valueType: 1
        },
        discountDescription: null,
        discountValueType: 0,
        discountValue: null,
        promocodeDescription: null,
        promocodeValueType: 0,
        promocodeValue: 0,
        currentChannelCommission: {
            productValueType: 1,
            productValue: 0,
            componentValueType: 1,
            componentValue: 0,
            isToOverwriteProduct: false,
            isToOverwriteComponent: false,
            transportValueType: 1,
            transportValue: 0
        },
        entityCommissionToComponentType: 1,
        entityCommissionToComponentValue: 0,
        totalProductGrossprice: 0,
        totalComponentGrossprice: 0,
        totalTransportGrossprice: 0,
        totalProductNetprice: 0,
        totalComponentNetprice: 0,
        totalTransportNetprice: 0,
        totalGrossprice: 0,
        totalDiscounts: 0,
        grandTotal: 0
    },
    bulkSelectedIds: [],
    isLoadingCalculations: false,
    calculationsGUID: null,
    selectedEventIdListReservations: null,

    // Resechedule
    isRescheduling: false,
    bookingComparisonRebook:null,
    newEventRebook:null,

    // Cancel tokens
    updateCheckinsNoShowsCancelToken: null,
    reservationEditCancelTokens: {},
    reservationCalculationsCancelToken: null,

    // Reservation listing | Also used for bulk actions
    reservationListFilters: null,
    reservationListType: RESERVATION_LIST_TYPE.DEPARTURE_DATE,
    reservationListAllSelected: false,
    isGettingReservationNr: false,

    // Pending payment edit
    pendingPaymentEdit: null,

    // Payments
    paymentsStatusList: [
        {
            label: 'Paid',
            id: 1,
            color: 'color-3',
            cssClass: 'bg-color-3',
        },
        {
            label: 'In Due',
            id: 0,
            color: 'color-5',
            cssClass: 'bg-color-5',
        },
        {
            label: 'Overpaid',
            id: 2,
            color: 'color-5',
            cssClass: 'bg-color-5',
        },
        {
            label: 'To Refund',
            id: 3,
            color: 'color-2',
            cssClass: 'bg-color-2',
        },
        {
            label: 'Fully Refunded',
            id: 4,
            color: 'dark',
            cssClass: 'bg-dark',
        },
        {
            label: 'Unpaid',
            id: 5,
            color: 'dark',
            cssClass: 'bg-dark',
        },
    ],

    // Refunds
    refundStatus: [
        {
            // This one should neve happen
            label: 'NONE',
            id:0,
            color: 'color-1'
        },
        {
            label: 'Refund Pending',
            id:1,
            color: 'color-5'
        },
        {
            label: 'Refund Confirmed',
            id:2,
            color: 'color-6'
        },
        {
            label: 'Refunded',
            id:10,
            color: 'color-6'
        },
        {
            label: 'Refund Canceled',
            id:-100,
            color: 'medium'
        },
    ],
    refundTypes: [
        {
            label: 'Total',
            id: 0
        },
        {
            label: 'Percentage or Value',
            id: 1
        },
        {
            label: 'Item Value',
            id: 2
        },
    ],

    refundAvailablePaymentMethods: [
        {
            seller: 'agent',
            channelType: 50,
            refund: [1, 2, 3],
            request: [-100],
            permissions: [
                {
                    role: 'admin',
                    accessType: 1,
                    refund: [1, 2, 3],
                    request: [-100],
                }
            ]
        },
        {
            seller: 'myTeam', // Custom
            channelType: 0,
            refund: [1, 2, 3],
            request: [5, 6, 7],
            permissions: [
                {
                    role: 'admin',
                    accessType: 1,
                    refund: [1, 2, 3],
                    request: [5, 6, 7],
                }
            ]
        },
        {
            seller: 'myTeam',
            channelType: 9999,
            refund: [1, 2, 3],
            request: [5, 6, 7],
            permissions: [
                {
                    role: 'admin',
                    accessType: 1,
                    refund: [1, 2, 3],
                    request: [5, 6, 7],
                }
            ]
        },
        {
            seller: 'widget',
            channelType: 101,
            refund: [],
            request: [-90],
            permissions: [
                {
                    role: 'admin',
                    accessType: 1,
                    refund: [1, 2, 3],
                    request: [],
                }
            ]
        },
        {
            seller: 'gyg',
            channelType: 202,
            refund: [],
            request: [-100],
            permissions: [
                {
                    role: 'admin',
                    accessType: 1,
                    refund: [1, 2, 3],
                    request: [],
                }
            ]
        },
    ],
    refundReasons: [
        {
            id:1,
            text: 'Climate conditions.'
        },
        {
            id:2,
            text: 'Equipment failure.'
        },
        {
            id:3,
            text: 'Minimal number not met.'
        },
        {
            id:0,
            text: 'Other'
        },
    ],
    payoutReasons: [
        {
            id:0,
            text: 'Other'
        },
        {
            id:1,
            text: 'Operator error.'
        },
    ],

    // Cancel Refund
    selectedRefund: null,
    refundPaymentId: null,
    refundTransactionCode: null,
    cancelRefundReasons: [
        {
            id:1,
            text: 'Supplier mistake'
        },
        {
            id:2,
            text: 'Customer changed his mind'
        },
        {
            id:0,
            text: 'Other'
        },
    ],
	reservationCancelNowOrRequest: null,
    isUpdatingReservation: false,
    lastSavedReservation: null,
    reservationBackup: null,
    reservationFilters: {
        resourceId: [],
        paymentStatus: [],
        countryId: null,
        status: [],
        currentCheckboxPickup: false,
        currentCheckboxNote: false,
        categories: []
    },
    reservationsType: null,
    isReservationCreationPayInPartialFullAmount: false,
};

const getters = {
    getReservationsFilters: (state) => state.reservationFilters,
    getReservationsType: (state) => state.reservationsType,
    getReservationCancelNow: (state) => state.reservationCancelNow,
	getReservationCancelNowOrRequest: (state) => state.reservationCancelNowOrRequest,
    getListFrom: (state) => state.listFrom,
    getListTo: (state) => state.listTo,
    getReservationsLabels: (state) => state.reservationsLabels,
    getReservationsPickupLabels: (state) => state.reservationsPickupLabels,
    getFilteredEvents: (state) => state.filteredEvents,
    getFilteredTime: (state) => state.filteredTime,
    getSelectedReservation: (state) => state.selectedReservation,
    getSelectedProductCommissions: (state) => state.selectedProductCommissions,
    getIsLoadingPeopleFinancials: (state) => state.loadingPeopleFinancials,
    getClonedReservation: (state) => state.clonedReservation,
    getNewReservationSetup: (state) => state.newReservationSetup,
    getInvoices: (state) => state.invoices,
    clonedReservation: (state) => state.clonedReservation,
    getReservations: (state) => state.reservations,
    getEventReservations: (state) => state.eventReservations,
    reservation: (state) => {
        return state.selectedReservation ? state.selectedReservation : state.newReservation;
    },
    getIsSavingReservation: (state) => state.isSavingReservation,
    getIsAddingReservation: (state) => state.isAddingReservation,
    getReservation: (state) => state.reservation,
    getReservationSelectedProduct: (state) => state.reservationSelectedProduct,
    getReservationSelectedEvent: (state) => state.reservationSelectedEvent,
    getReservationCalculations: (state) => state.reservationCalculations,

    // Reschedule
    getIsRescheduling: (state) => state.isRescheduling,
    getBookingComparisonRebook: (state) => state.bookingComparisonRebook,
    getNewEventRebook:(state)=>state.newEventRebook,

    getBulkSelectedIds: (state) => state.bulkSelectedIds,
    getIsLoadingCalculations: (state) => state.isLoadingCalculations,
    getIsGettingReservationById: (state) => state.isGettingReservationById,
    getSelectedEventListReservations: (state) => state.selectedEventIdListReservations,
    getReservationListFilters: (state) => state.reservationListFilters,
    getReservationListType: (state) => state.reservationListType,
    getIsGettingReservationNr: (state) => state.isGettingReservationNr,
    getPaymentsStatusList: (state) => state.paymentsStatusList,
    getPaymentState: (state, getters) => (id) => {
        let foundState = state.paymentsStatusList.find(state => state.id == id)
        return foundState? foundState : 'n'
    },

    // Refunds
    getRefundStatus: (state) => state.refundStatus,
    getRefundTypes: (state) => state.refundTypes,
    getRefundAvailablePaymentMethods: (state) => state.refundAvailablePaymentMethods,
    getRefundReasons: (state) => state.refundReasons,
    getPayoutReasons: (state) => state.payoutReasons,
    getSelectedRefund: (state) => state.selectedRefund,
    getRefundPaymentId: (state) => state.refundPaymentId,
    getRefundTransactionCode: (state) => state.refundTransactionCode,
    getCancelRefundReasons: (state) => state.cancelRefundReasons,
    getIsUpdatingReservation: (state) => state.isUpdatingReservation,
    getLastSavedReservation: (state) => state.lastSavedReservation,
    getReservationBackup: (state) => state.reservationBackup,
    getPendingPaymentEdit: (state) => state.pendingPaymentEdit,
    getIsReservationCreationPayInPartialFullAmount: (state) => state.isReservationCreationPayInPartialFullAmount,
}

const actions = {
    setReservationsFilters: ({ commit }, val) => {
        commit('SET_RESERVATION_FILTERS', val);
    },
    setIsReservationCreationPayInPartialFullAmount: ({ state }, val) => {
        state.isReservationCreationPayInPartialFullAmount = val;
    },
    resetReservationsFilters: ({ commit }) => {
        commit('RESET_RESERVATION_FILTERS');
    },

    setReservationsType: ({ commit }, val) => {
        commit('SET_RESERVATION_TYPE', val);
    },

    resetReservationsType: ({ commit }) => {
        commit('RESET_RESERVATION_TYPE');
    },

    setReservationBackup: ({ commit }, val) => {
        commit('SET_RESERVATION_BACKUP', val);
    },
    
    resetReservationBackup: ({ commit }) => {
        commit('RESET_RESERVATION_BACKUP');
    },

    setReservationCancelNow: ({ commit }, val) => {
        commit('SET_RESERVATION_CANCEL_NOW', val)
    },

	setReservationCancelNowOrRequest: ({ commit }, val) => {
		// Val should be a string 'now' or 'request'
		commit('SET_RESERVATION_CANCEL_NOW_OR_REQUEST', val)
	},

    async initReservations({ commit }) {
        try {
            if (response && response.status === 200 && response.data) {
                commit('INIT_RESERVATIONS', {
                    reservations: response.data,
                    reservationsLabels: {
                        startDate: 'Start date',
                        reservation: 'Reservation',
                        fullName: 'Name',
                        seller: 'Agent/Seller',
                        pax: 'PAX',
                        sellDate: 'Event Dates',
                        statusDescription: 'Status',
                        totalPrice: 'Total',
                        checkin: 'Check-in',
                        noshow: 'No Show',
                    },
                    pickupLabels: {
                        pickupDate: 'PickUp Date',
                        from: 'From',
                        to: 'To',
                        customer: 'Customer',
                        reservation: 'Reservation',
                        pax: 'PAX',
                        language: 'Language',
                        departure: 'Departure',
                        notes: 'Notes & Alerts',
                    },
                });

                return true;
            }

            return false;
        }
        catch (error) {}
    },

    setEventReservations({ commit, rootState }, eventId) {
         return axios.get('/api/reservation/ListReservation', {
            params: {
                supplierId: rootState.user.account.supplierId,
                eventId: eventId
            }
        }).then(response => {
            if (response.status == 200 && response.data) {
                commit('SET_EVENTRESERVATIONS', response.data);
            }
        })
    },

    // Narrows down the list of reservations
    filterReservationsList: ({ commit }, list) => {
        commit('FILTER_RESERVATIONS_LIST', list);
    },

    // Updates date range in reservations list
    updateDateRange: ({ commit }, range) => {
        commit('UPDATE_RESERVATIONS_DATE_RANGE', range);
    },

    // Updates date range in reservations list
    searchByQuery: ({ commit }, query) => {
        commit('UPDATE_RESERVATIONS_QUERY', query);
    },

    // Resets the new reservation setup window to its default filters.
    // Waits for both the categories and events to be init'd before updating
    async resetNewReservationSetup ({ commit, dispatch, rootState }) {
        // Default from/to ranges must ensure we're not showing events from the past
        let from = moment().format('YYYY-MM-DD');
        let to = moment().add(rootState.settings.eventsRangeDays, 'days').format('YYYY-MM-DD');
        let params = { from: from, to: to };

        let categoriesResponse = await dispatch('initCategories');
        let eventsResponse = await dispatch('initEvents', params);

        if (categoriesResponse && eventsResponse) {
            dispatch('closeModal');

            commit('UPDATE_FIELDS', {
                object: 'newReservationSetup',
                fields: {
                    from: from,
                    to: to,
                    dates: null,
                    time: null,
                    event: null,
                    query: null,
                    pax: null,
                    list: rootState.inventory.events
                }
            });

            return true;
        }
    },

    // Updates the new reservation filters with the provided list of results
    // for this given filter. Afterwards, applies the filter itself to the current
    // array of results (merging previous filters)
    updateNewReservationSetup: ({ commit, state, rootState }, fields) => {
        commit('UPDATE_FIELDS', { object: 'newReservationSetup', fields });

        var newReservationSetup = state.newReservationSetup;
        var list = rootState.inventory.events;

        for (var key in newReservationSetup) {
            var filter = newReservationSetup[key];

            // Match against all 'sub-arrays' (from and to are control date strings, so we skip them)
            if (key !== 'list' && key !== 'from' && key !== 'to' && filter && filter.length > 0) {
                list = _.intersection(list, filter);
            }
        }

        commit('INTERSECT_NEW_RESERVATION_SETUP_CHOICES', list);
    },

    // Forces the list of events to be emptied
    emptyNewReservationSetupList: ({ commit }) => {
        commit('UPDATE_FIELDS', {
            object: 'newReservationSetup',
            fields: { list: [] }
        });
    },

    // Forces the list of events to be cleared
    clearNewReservationSetupList: ({ commit, rootState }) => {
        commit('UPDATE_FIELDS', {
            object: 'newReservationSetup',
            fields: { list: rootState.company.events }
        });
    },

    // Updates a brand new reservation with the specified fields
    updateNewReservation: ({ commit, state }, fields) => {
        commit('UPDATE_FIELDS', { object: 'newReservation', fields: fields });
    },

    setSelectedReservation: ({ commit }, data) => {
        commit('SET_SELECTED_RESERVATION', data);
    },

    resetSelectedReservation: ({ commit }) => {
        commit('RESET_SELECTED_RESERVATION');
    },

    resetLastSavedReservation: ({ commit }) => {
        commit('RESET_LAST_SAVED_RESERVATION');
    },

    downloadSelectedProductCommissions: ({commit, rootState, state}, productId) => {
        state.loadingPeopleFinancials = true
        
        return axios.get('api/supplier/GetPeopleFinancials', {
            params:{
                supplierId: rootState.user.account.supplierId,
                productid: productId
            }
        }).then(response => {
            state.loadingPeopleFinancials = false
            commit('UPDATE_SELECTED_PRODUCT_COMMISSONS', response.data)
            state.selectedProductCommissionsProductId = productId
        }).catch(err => {
            state.loadingPeopleFinancials = false
        })
    },

    // Reverts current changes to the reservation to its previous state when editing
    revertReservationChanges: ({ commit }, pre) => {
        commit('REVERT_RESERVATION_CHANGES', pre);
    },

    // Clears the currently active reservation
    clearActiveReservation: ({ commit }) => {
        commit('CLEAR_ACTIVE_RESERVATION');
    },

    // Adds a new payment
    addReservationPayment: ({ commit, state, getters }, payment) => {
        commit('ADD_PAYMENT', { reservation: getters.reservation, payment: payment });
    },

    // Deletes the current payment
    deleteReservationPayment: ({ commit }, data) => {
        commit('DELETE_PAYMENT', data);
    },

    // Adds a new refund
    addReservationRefund: ({ commit }, refund) => {
        commit('ADD_REFUND', refund);
    },

    // Adds a new note. Supports adding both to the new reservation and the selected reservation (create and edit mode)
    addReservationNote: ({ commit, getters }, note) => {
        commit('ADD_RESERVATION_NOTE', { reservation: getters.reservation, note: note });
    },

    addReservationPromo: ({ commit, getters }, promo) => {
        commit('UPDATE_RESERVATION_PROMO', { reservation: getters.reservation, promo: promo });
    },

    deleteReservationPromo: ({ commit, getters }) => {
        commit('UPDATE_RESERVATION_PROMO', { reservation: getters.reservation, promo: null });
    },

    // Adds an item (placebo for update method)
    // Parameters: { action: 'edit', object: 'category', table: 'categories', fields: { object } }
    addReservation: ({ dispatch }, data) => {
        dispatch('updateReservation', data);
        dispatch('closeModal');
    },

    updateReservation: ({ dispatch, state }, data) => {
        if (!data.action) {
            throw new Error('Invalid action on updateReservation');
        }

        state.isUpdatingReservation = true;

        const action = data.action.charAt(0).toUpperCase() + data.action.slice(1);
        let msg = 'Reservation saved successfully!';

        if (data.action === 'cancel') {
            msg = 'Reservation canceled successfully!';
        }

        axios.post('/api/reservation/Reservation' + action, data.fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initReservations');

                Vue.router.push({ name: 'reservations' });
                Vue.toasted.success(msg);

                dispatch('clearClonedReservation');
            }

            state.isUpdatingReservation = false;
        })
        .catch(() => {
            state.isUpdatingReservation = false;
        });
    },

    rescheduleReservation: ({ dispatch }, fields) => {
        axios.post('/api/reservation/reschedule', fields).then((response) => {
            if (response && response.status === 200) {
                dispatch('initReservations');
                dispatch('closeModal');

                Vue.router.push({ name: 'reservations' });
                Vue.toasted.success('Reservation rescheduled successfully!');

                dispatch('clearClonedReservation');
            }
        })
        .catch(() => {});
    },

    // Finishes cancelling a reservation and ties it with a description
    cancelReservation: ({ dispatch }, data) => {
        dispatch('updateReservation', data);
        dispatch('closeModal');
    },

    // Sets up the new reservation field set to its blank state.
    // Clears everything before doing so
    resetClonedReservation: ({ commit, dispatch }) => {
        dispatch('clearActiveReservation').then(() => {
            commit('UPDATE_CLONED_RESERVATION', {
                    salesDate: null,
                    status: null,
                    dealType: null,
                    notes: null,
                    event: null,
                    customer: null,
                    agent: null,
                    billing: {
                        promoCode: '',
                        promoCodeDiscountType: null,
                        promoCodeDiscountCode: null,
                        discountType: null,
                        discountValue: null,
                        description: '',
                        details: null,
                        invoices: null,
                        payments: null,
                    },
                    transport: null,
            });
        });
    },

    // Replaces the whole cloned reservation object with the new one.
    // We're doing this to avoid not hydrating deep nested arrays
    updateClonedReservation: ({ commit, state }, form) => {
        commit('UPDATE_CLONED_RESERVATION', form);
    },

    // Clears only cloned reservation
    clearClonedReservation: ({ commit }) => {
        commit('CLEAR_CLONED_RESERVATION');
    },

    //new reservation 29/11/2017
    //the following action have "existing" on their name, I know it's stupid but it's to avoid conflicts with older actions
    setReservation: ({ commit }, payload) => {
        commit('SET_RESERVATION', payload);
    },

    resetReservation: ({ commit }) => {
        commit('RESET_RESERVATION')
    },

    setReservationSelectedProduct: ({ commit }, payload) => {
        commit('SET_RESERVATION_SELECTED_PRODUCT', payload);
    },

    setReservationSelectedEvent: ({ commit }, payload) => {
        commit('SET_RESERVATION_SELECTED_EVENT', payload);
    },
    setNewEventRebook: ({ commit }, payload) => {
        commit('SET_NEW_EVENT_REBOOK', payload);
    },

    createNewReservation: ({ dispatch }, payload) => {
        if (!state.isAddingReservation) {
            return dispatch('saveNewReservation', payload);
        }
    },

    saveNewReservation: (_, payload) => {
        state.isAddingReservation = true;

        return new Promise((resolve, reject) => {
            axios.post('/api/reservation/create', payload).then((response) => {
                state.isAddingReservation = false;
                resolve(response);

                return response;
            })
            .catch((error) => {
                state.isAddingReservation = false;
                reject(error);

                return error;
            });
        })
    },

    updateExistingReservation: async ({ commit, dispatch, state }, payload) => {
        if (payload.reservation.changeStatusTo) {
            payload.reservation.status = payload.reservation.changeStatusTo;
        }

        const reservationId = payload.reservation.id;
        const isEditingSelectedReservation = state.selectedReservation && state.selectedReservation.id === reservationId;

        // Cancel only the previous edit for this reservation
        if (state.reservationEditCancelTokens[reservationId]) {
            state.reservationEditCancelTokens[reservationId].cancel;
        }

        const source = axios.CancelToken.source();
        if (reservationId) {
            state.reservationEditCancelTokens[reservationId] = source;
        }

        if (isEditingSelectedReservation) {
            state.isSavingReservation = true;
            state.isGettingReservationById = true;
        }

        try {
            const editResp = await reservationService.editReservation(payload, source.token);

            if (state.reservationEditCancelTokens[reservationId] === source) {
                delete state.reservationEditCancelTokens[reservationId];
            }

            if (isEditingSelectedReservation) {
                state.isGettingReservationById = false;
                state.isSavingReservation = false;
            }

            if (editResp.status !== 200) return editResp;

            dispatch('initReservations');

            if (state.pendingPaymentEdit) {
                await payInService.editPayIn(state.pendingPaymentEdit);
                state.pendingPaymentEdit = null;
            }


            if (isEditingSelectedReservation) {
                await dispatch('refreshCurrentSelectedReservation');
            }

            Vue.toasted.success('Reservation saved');

            if (state.selectedEventIdListReservations) {
                Vue.router.push({ name: 'reservationsEvent' });
            } else {
                Vue.router.push({ name: 'reservations' });
            }

            return editResp;
            
        } catch(error) {
            if (isEditingSelectedReservation) {
                state.isSavingReservation = false;
                state.isGettingReservationById = false;
            }

            throw error;
        }
    },

    cancelExistingReservation: ({ dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            axios.post('/api/reservation/ReservationCancel', payload).then((response) => {
                if (response && response.status === 200) {
                    dispatch('initReservations');
                    Vue.router.push({ name: 'reservations' });
                    Vue.toasted.success('Reservation canceled');

                    resolve(response);
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    checkPricesForRebook: ({rootState, state}, payload) => {
        state.isRescheduling = true;
        let payloadRebook = payload;

        return axios.get('/api/reservation/reschedule/validate', {
            params: {
                bookingId: payloadRebook.bookingId ,
                newEventId: payloadRebook.newEventId
            }
        }).then((response) => {
            state.isRescheduling = false;

            if (response && response.status === 200) {
                state.bookingComparisonRebook = response.data;

                return response;
            }
        })
        .catch((error) => {
            state.isRescheduling = false;

            return error;
        });

    },
    rescheduleExistingReservation: ({ state }, payload) => {
        state.isRescheduling = true;

        return axios.post('/api/reservation/reschedule', payload).then((response) => {
            state.isRescheduling = false;

            if (response && response.status === 200) {
                Vue.toasted.success('Reservation rescheduled successfully!');

                return response;
            }
        })
        .catch((error) => {
            state.isRescheduling = false;

            return error;
        });
    },

    updateCheckinsNoShows: ({ state }, payload) => {
        if (state.updateCheckinsNoShowsCancelToken) {
            state.updateCheckinsNoShowsCancelToken.cancel();
        }

        let source = axios.CancelToken.source();
        state.updateCheckinsNoShowsCancelToken = source;

        return axios.post('/api/booking/DoCheckIn', payload, {
            cancelToken: source.token
        }).then((response) => {
            if (response && response.status === 200) {
                return response;
            }
        })
        .catch(() => {});
    },

    pushReservationToStore: ({ commit }, reservation) => {
        commit('PUSH_RESERVATION', reservation)
    },

    setReservationCalculations: ({ state, commit, rootState }, payload) => {
        if (state.reservationCalculationsCancelToken) {
            state.reservationCalculationsCancelToken.cancel();
        }

        let source = axios.CancelToken.source();
        state.reservationCalculationsCancelToken = source;

        var reservation;
        var skipCommitCalculations = false;

        if (!payload.reservation) {
            reservation = payload;
        } else {
            reservation = payload.reservation;
            skipCommitCalculations = payload.onlyCalculate? payload.onlyCalculate : false;
        }

        state.isLoadingCalculations = true;

        return axios.post(
            'api/booking/SupplierCalculatePricing',
            {
                reservation: reservation,
            },
            {
                cancelToken: source.token
            }
        ).then(response => {
            state.isLoadingCalculations = false;

            if (response.status == 200 && skipCommitCalculations == false) {
                commit('SET_RESERVATION_CALCULATIONS', response.data);

                // Saves the calculationsGuid to use on future calculation request to speed them up
                state.calculationsGUID = response.data.calculationsGUID;
            }
            return response;
        }).catch(error => {
            return error;
        })
    },

    addToBulkSelectedIds: ({state}, payload) => {
        for (let idToAdd of payload) {
            if(!state.bulkSelectedIds.includes(idToAdd)){
                state.bulkSelectedIds.push(idToAdd)
            }
        }
    },

    removeFromBulkSelectedIds: ({state}, payload) => {
        for (let idToRemove of payload) {
            if(state.bulkSelectedIds.includes(idToRemove)){
                state.bulkSelectedIds.splice(state.bulkSelectedIds.indexOf(idToRemove),1)
            }
        }
    },

    setBulkSelectedIds: ({state}, payload) => {
        state.bulkSelectedIds = payload
    },

    resetCalculationsGuid: ({state}) => {
        state.calculationsGUID = null
    },

    openReservationById: async ({ state, rootState, dispatch, commit }, reservationId) => {
        state.isGettingReservationById = true;
        eventHub.$emit('loading', true);

        try {
            const response = await reservationService.openReservationById(
                rootState.user.account.supplierId,
                reservationId
            );

            state.isGettingReservationById = false;
            eventHub.$emit("loading", false);

            if (!response || !response.ok) {
                Vue.toasted.info(`Ticket #${reservationId} not found`);
                return response;
            }

            const data = response.value;

            if (data) {
                commit("PUSH_RESERVATION", data);
                commit("SET_SELECTED_RESERVATION", {
                    payload: data,
                    isToResetFlags: true,
                });

                dispatch("openModal", "ReservationEditV2");
            }

            return response;

        } catch (error) {
            state.isGettingReservationById = false;
            eventHub.$emit("loading", false);

            return error;
        }
    },

    setPendingPaymentEdit: ({ state }, payload) => {
        state.pendingPaymentEdit = payload;
    },

    deletePayment: async ({ dispatch }, paymentId) => {
        const result = await payInService.deletePayIn(paymentId)
        if (!result.ok) {
            Vue.toasted.error(result.message)
            return result
        }
        await dispatch('refreshCurrentSelectedReservation')
        return result
    },

    refreshCurrentSelectedReservation: ({commit, dispatch, state, rootState}) => {
        state.isGettingReservationById = true;
        
        // Test if ticket exists
        return axios.get('api/reservation/FindReservationBySupplier', {
            params: {
                supplierId: rootState.user.account.supplierId,
                reservationId: state.selectedReservation.id
            }
        }).then((response) => {
            state.isGettingReservationById = false
            if (response !== null && response !== undefined && response.status == 200) {
                if (response.data !== null) {
                    commit('SET_SELECTED_RESERVATION', {payload: response.data, isToResetFlags: true});
                    dispatch('setReservationCalculations', response.data);
                } else {
                    Vue.$toasted.info('There was a problem loading this reservation, please try again');
                }

                return response;
            }
        }).catch((error) => {
            state.isGettingReservationById = false;

            return error;
        });
    },

    setSelectedEventListReservations: ({state}, event) => {
        state.selectedEventIdListReservations = event;
    },

    setReservationListFilters: ({state}, payload) => {
        state.reservationListFilters = payload;
    },
    setReservationListType: ({state}, payload) => {
        state.reservationListType = payload;
    },
    setReservationListAllSelected: ({state}, payload) => {
        state.reservationListAllSelected = payload;
    },
    getNumberForNewReservation: ({state, rootState}, payload) => {
        state.isGettingReservationNr = true;

        return axios.get('api/booking/GetBookingSequencialNumber', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            state.isGettingReservationNr = false;

            return response;
        }).catch(err => {
            state.isGettingReservationNr = false;

            return err;
        })
    },

    // REFUNDS
    executeRefund: ({state, rootState}, payload) => {
        return axios.post('api/Booking/RefundConfirmation', {
            userAccount: rootState.user.account,
            supplierId: rootState.user.account.supplierId,
            bookingId: payload.reservation.id,
            refundId: payload.refund.id,
        }).then(response => {
            state.isGettingReservationNr = false;

            return response;
        }).catch(err => {
            state.isGettingReservationNr = false;

            return err;
        })
    },

    selectRefund: ({ commit }, refund) => {
        return commit('SELECT_REFUND', refund);
    },

    setRefundPaymentId: ({ state }, id) => {
        state.refundPaymentId = id
    },

    setRefundTransactionCode: ({ state }, transactionCode) => {
        state.refundTransactionCode = transactionCode
    },

    cancelRefund: ({ }, payload) => {
        let params = {
            bookingId: payload.reservation.id,
            refundId: payload.refund.id,
            refundCode: payload.refund.code,
            refundCancelationReasonType: payload.reason.id,
            refundCancelationReasonDescription: payload.description,
        }

        return axios.post('/api/Booking/refund/cancel', params).then((response) => {
            return response
        }).catch(err => {
            return err
        })
    },

    sendPaymentLinkByEmail: ({ rootState, state }) => {
        const supplierId = rootState && rootState.user && rootState.user.account && rootState.user.account.supplierId;
        const bookingId = state && state.selectedReservation && state.selectedReservation.id;

        return axios.post(
            `api/Reservation/SendBookingPaymentLinkByEMail?supplierid=${supplierId}&bookingId=${bookingId}`
        ).then(response => {
            return response.data;
        }).catch(err => {
            throw err;
        });
    },
};

export const mutations = {
    SET_RESERVATION_FILTERS(state, val) {
        state.reservationFilters = val;
    },

    RESET_RESERVATION_FILTERS(state) {
        state.reservationFilters =  {
            resourceId: [],
            paymentStatus: [],
            countryId: null,
            status: [],
            currentCheckboxPickup: false,
            currentCheckboxNote: false,
            categories: []
        };
    },

    SET_RESERVATION_TYPE(state, val) {
        state.reservationsType = val;
    },

    RESET_RESERVATION_TYPE(state) {
        state.reservationsType = null;
    },


    SET_RESERVATION_BACKUP(state, val) {
        state.reservationBackup = val;
    },

    RESET_RESERVATION_BACKUP(state) {
        state.reservationBackup = null;
    },
    
    // Deletes a given item from both the full listing and the filtered listing
    DELETE_RESERVATION: (state, item) => {
        Vue.delete(state.reservations, item);
        Vue.delete(state.list, item);
    },

    SET_RESERVATION_CANCEL_NOW(state, val) {
        state.reservationCancelNow = val;
    },
	SET_RESERVATION_CANCEL_NOW_OR_REQUEST(state, val) {
		state.reservationCancelNowOrRequest = val;
	},

    INIT_RESERVATIONS: (state, data) => {
        var from = moment();
        var to = moment().add(7, 'days');

        state.reservations = data.reservations;
        state.reservationsLabels = data.reservationsLabels;
        state.reservationsPickupLabels = data.pickupLabels;
        state.invoicesLabels = {
            date: 'Date',
            description: 'Description',
            type: 'Type',
            value: 'Amount',
            status: 'Status'
        };

        // Store range as strings
        state.listFrom = from;
        state.listTo = to;
    },

    SET_EVENTRESERVATIONS: (state, data) => {
        state.eventReservations = data;
    },

    RESET_SELECTED_RESERVATION: (state) => {
        state.selectedReservation = null;
    },

    // Sets the selected reservation across the store
    SET_SELECTED_RESERVATION: (state, payload) => {
        const {payload: finalPayload, isToResetFlags} = payload;

        state.pendingPaymentEdit = null;
        if (finalPayload !== null) {
            const selectedReservationCopy = structuredClone(finalPayload);

            if (!selectedReservationCopy.updateFlags) {
                selectedReservationCopy.updateFlags = {};
            } else if (isToResetFlags){
                Object.keys(selectedReservationCopy.updateFlags).forEach(k => {
                    selectedReservationCopy.updateFlags[k] = false;
                });
            }
            (selectedReservationCopy.bookingComponents || []).forEach(reservationComponent => {
                if (reservationComponent.availableQuantity === undefined || reservationComponent.availableQuantity === null) {
                    reservationComponent.availableQuantity = reservationComponent.quantityAvailable;
                }
            });

            if (selectedReservationCopy.event.eventComponents) {
                selectedReservationCopy.bookingComponents.map(reservationComponent => {
                    let eventComponent = selectedReservationCopy.event.eventComponents.filter(r => {
                        return r.component.id == reservationComponent.component.id && r.componentPrice.id == reservationComponent.componentPrice.id
                    })[0];

                    // Only if the component / extra is still available
                    if (eventComponent) {
                        reservationComponent.originalQuantity = eventComponent.quantity;
                        reservationComponent.quantityAvailable = eventComponent.quantityAvailable;
                    } else {
                        // We enter this "else" if the extra on the reservation is no longer part of the product
                        reservationComponent.componentExtinct = true;
                    }
                })
            }

            const initGrossPrice = item => { item.grossPrice = item.grossPrice || 0 }

            ;(selectedReservationCopy.payments || []).forEach(payment => {
                (payment.components || []).forEach(initGrossPrice)
                ;(payment.tickets || []).forEach(initGrossPrice)
            })

            const refundById = new Map();
            ;(selectedReservationCopy.payments || []).forEach(payment => {
                (payment.refunds || []).forEach(refund => {
                    if (!refund || !refund.id) {
                        return;
                    }

                    if (!refundById.has(refund.id)) {
                        refundById.set(refund.id, refund);
                    }
                });
            });

            if(!selectedReservationCopy.generalRefunds){
                selectedReservationCopy.generalRefunds = selectedReservationCopy.refunds;
            }

            selectedReservationCopy.refunds = Array.from(refundById.values());
            state.selectedReservation = selectedReservationCopy;
                state.lastSavedReservation = JSON.parse(JSON.stringify(selectedReservationCopy));

        }
    },

    RESET_LAST_SAVED_RESERVATION: (state) => {
        state.lastSavedReservation = null;
    },

    // Filters the full reservations list
    FILTER_RESERVATIONS_LIST: (state, list) => {
        state.reservations = list;
    },

    // Filters by date range
    UPDATE_RESERVATIONS_DATE_RANGE: (state, range) => {
        if (range.from !== undefined && range.from) {
            state.listFrom = range.from;
        }

        if (range.to !== undefined && range.to) {
            state.listTo = range.to;
        }

        var from = state.listFrom;
        var to = state.listTo;
        var filtered = state.reservations;

        // Filter list by salesDate according to the chosen from/to dates
        if (from && to) {
            filtered = filtered.filter(r => {
                var salesDate = moment(r.salesDate);

                if (salesDate.diff(from) >= 0 && salesDate.diff(to) <= 0) {
                    return r;
                }
            });
        }

        state.reservations = filtered;
    },

    // Filters by query
    UPDATE_RESERVATIONS_QUERY: (state, query) => {
        state.query = query;
    },

    // This mutation will handle the merging of all setup filters
    // from across the reservation add modal. This includes the
    // text search, date ranges, people mapping, product filtering
    // and timeframe filtering. The resulting list will be an 'inner
    // join calculated between all filtering possibilities so that
    // we're always narrowing/expanding the current list
    INTERSECT_NEW_RESERVATION_SETUP_CHOICES: (state, list) => {
        state.newReservationSetup.list = list;
    },

    // Reverts an auto-saving edition back to the original reservation we had before editing.
    REVERT_RESERVATION_CHANGES: (state, old) => {
        var item = state.reservations.find(r => r.id === old.id);

        if (item) {
            var i = _.indexOf(state.reservations, item);

            if (i != -1) {
                state.reservations.splice(i, 1, old);
            }
        }
    },

    // Clears the currently active reservation, be it the selectedReservation or the newReservation object
    CLEAR_ACTIVE_RESERVATION: (state) => {
        state.selectedReservation = null;
        state.newReservation = null;
        state.clonedReservation = null;
        state.pendingPaymentEdit = null;
    },

    // Updates a set of fields in an object
    UPDATE_FIELDS: (state, data) => {
        if (state[data.object] === undefined || !state[data.object]) {
            state[data.object] = {};
        }

        Object.keys(data.fields).forEach((key) => {
            Vue.set(state[data.object], key, data.fields[key]);
        });
    },

    // Remove action and mutation!!
    ADD_PAYMENT: (state, data) => {
        var reservation = data.reservation;

        if (reservation.payments === undefined) {
            Vue.set(reservation, 'payments', []);
        }

        // Copy the list of payments, operate on it, and save it from scratch
        let paymentList = JSON.parse(JSON.stringify(reservation.payments));

        paymentList.push(data.payment);

        Vue.set(reservation, 'payments', paymentList);
    },

    // Removes a payment method row
    DELETE_PAYMENT: (state, data) => {
        data.collection.splice(data.index, 1);
    },

    // Sets a payment description for the given reservation
    ADD_PAYMENT_DESCRIPTION: (state, data) => {
        if (state[data.object].billing === undefined) {
            Vue.set(state[data.object], 'billing', []);
        }

        Vue.set(state[data.object].billing, 'description', data.description);
    },

    // Adds a new refund entry to the active reservation
    ADD_REFUND: (state, refund) => {
        if (state.selectedReservation.billing.refunds === undefined) {
            state.selectedReservation.billing.refunds = [];
        }

        state.selectedReservation.billing.refunds.push(refund);
    },

    UPDATE_RESERVATION_PROMO: (state, data) => {
        data.reservation.billing.promo_id = data.promo;
    },

    CANCEL_RESERVATION: (state, data) => {
        var reservation = state.reservations.find(r => r.id === data.reservation.id);

        Vue.set(reservation, 'status', 'canceled');
    },

    UPDATE_CLONED_RESERVATION: (state, data) => {
        state.clonedReservation = data;
    },

    CLEAR_CLONED_RESERVATION: (state) => {
        state.clonedReservation = null;
    },

    SET_RESERVATION_SELECTED_PRODUCT: (state, data) => {
        state.reservation.product = data
    },

    SET_NEW_EVENT_REBOOK: (state, data) => {
        state.newEventRebook = data
    },
    SET_RESERVATION_SELECTED_EVENT: (state, data) => {
        state.reservation.event = data
    },

    SET_RESERVATION: (state, data) => {
        state.reservation = data
    },

    PUSH_RESERVATION: (state, reservation) => {
        state.reservations.push(reservation)
    },

    RESET_RESERVATION: (state) => {
        // Resets the number of people
        if(state.reservation.event.eventGenderPrices && state.reservation.event.eventGenderPrices.length > 0){
            state.reservation.event.eventGenderPrices.map((item) => {
                item.quantityToBook = 0;
            })
        }

        state.reservation = {
            agent: {},
            product:state.reservation.product,
            event:state.reservation.event,
            billing:{
                promoCode: "",
                promoCodeDiscountType: null,
                promoCodeDiscountCode: null,
                discountType: 0,
                discountValue: null,
                description: "",
                details: {
                    vat: "",
                    businessName: "",
                    address: "",
                    city: "",
                    country: 176
                },
                invoices: null,
            },
            payments: [],
            currentChannelCommission: {
                productValueType: 1,
                productValue: 0,
                componentValueType: 1,
                componentValue: 0,
                isToOverwriteProduct: false,
                isToOverwriteComponent: false,
                transportValueType: 1,
                transportValue: 0
            },
            customer:{
                prefix: null,
                name: null,
                surname: null,
                phone: null,
                accomodation: null,
                room: null,
                email: null,
                country: null,
                dial: null,
                isInvalid: true,
                sendEmailCopy: true
            },
            helper: {
                totalToPay: null,
            },
            transport:{
                transfers:[]
            },
            notes: [
                {
                    note: null,
                    noteVisibilityMomentType: 1,
                    type: 1
                }
            ],
            creatorAgent: null,
            creatorSupplier: null,
            creatorUserAccount: null,
            lastUpdatedBy: null,
            lastUpdatedDate: null 
        }
    },

    SET_RESERVATION_CALCULATIONS: (state, data) => {
        state.reservationCalculations = data;
    },

    UPDATE_SELECTED_PRODUCT_COMMISSONS: (state, data) => {
        state.selectedProductCommissions = data;
    },

    SELECT_REFUND: (state, data) => {
        state.selectedRefund = data;
    },

    SET_PENDING_PAYMENT_EDIT: (state, payload) => {
        state.pendingPaymentEdit = payload;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reservations.js